import DocViewer, { DocViewerRenderers, IDocument } from "react-doc-viewer";
import XLSXViewer from "./XLSXViewer";
import DOCXViewer from "./DOCXViewer";
import SVGViewer from "./SVGViewer";
import CSVViewer from "./CSVViewer";
import PDFViewer from "./PDFViewer";
const DocViewerComponent = ({ documents }: { documents: IDocument[] }) => {
  const customRenderers = [
    ...DocViewerRenderers,
    XLSXViewer,
    DOCXViewer,
    SVGViewer,
    CSVViewer,
    PDFViewer,
  ];
  return (
    <DocViewer
      documents={documents}
      pluginRenderers={customRenderers}
      style={{ height: 800 }}
      config={{
        header: {
          disableFileName: false,
          retainURLParams: true,
        },
      }}
      theme={{
        primary: "#146C94",
        secondary: "#ffffff",
        tertiary: "#146C94",
        text_primary: "#ffffff",
        text_secondary: "#232323",
        text_tertiary: "#00000099",
      }}
    />
  );
};

export default DocViewerComponent;
